import type { EChartsOption } from 'echarts';

export interface FacilityRankingRow {
  name: string;
  score: number;
  facilities: number;
  assessments: number;
}

function scoreColor(score: number): string {
  if (score >= 90) return '#22c55e';
  if (score >= 75) return '#eab308';
  if (score >= 60) return '#f97316';
  return '#ef4444';
}

/** Builds the ECharts option for the horizontal "facility type performance" ranking bar chart. */
export function buildFacilityRankingBarOption(
  sorted: FacilityRankingRow[],
  yAxisW: number,
  barH: number,
  borderColor = '#E2ECE6'
): EChartsOption {
  return {
    grid: { left: yAxisW + 12, right: 56, top: 4, bottom: 4, containLabel: false },
    xAxis: {
      type: 'value',
      min: 0,
      max: 100,
      splitNumber: 5,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { lineStyle: { color: borderColor, type: 'dashed' } },
      axisLabel: { fontSize: 10, color: '#9ca3af', formatter: (v: number) => `${v}%` },
    },
    yAxis: {
      type: 'category',
      data: sorted.map(d => d.name),
      inverse: true,
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { fontSize: 10, color: '#374151', width: yAxisW, overflow: 'truncate' },
    },
    tooltip: {
      trigger: 'item',
      backgroundColor: '#fff',
      borderColor: borderColor,
      borderWidth: 1,
      textStyle: { fontSize: 12, color: '#111827' },
      padding: [8, 12],
      formatter: (params: unknown) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const p = params as any;
        const row = sorted[p.dataIndex];
        return `${row.score.toFixed(1)}% avg · ${row.facilities} facilities · ${row.assessments} assessments`;
      },
    },
    series: [
      {
        type: 'bar',
        data: sorted.map(d => ({
          value: d.score,
          itemStyle: { color: scoreColor(d.score), opacity: 0.85, borderRadius: [0, 4, 4, 0] },
        })),
        barMaxWidth: barH,
        barCategoryGap: '22%',
        label: {
          show: true,
          position: 'right',
          formatter: (params: unknown) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const p = params as any;
            return `${(p.value as number).toFixed(1)}%`;
          },
          fontSize: 10,
          color: '#6b7280',
          fontWeight: 600,
        },
      },
    ],
  };
}
